var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBonusCoin = function SvgBonusCoin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 31 30"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "bonus-coin_svg__a",
    d: "M0 0h30.413v30.067H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bonus-coin_svg__c",
    d: "M0 0h24.128v26.438H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.587 -.067)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "bonus-coin_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bonus-coin_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.207 30.067c8.375 0 15.206-6.753 15.206-15.034C30.413 6.754 23.583 0 15.207 0S0 6.753 0 15.034c0 8.28 6.831 15.034 15.207 15.034",
    fill: "#F5BE14",
    mask: "url(#bonus-coin_svg__b)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.871 -.067)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "bonus-coin_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bonus-coin_svg__c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.922 0c8.398 0 15.206 6.73 15.206 15.033 0 4.562-2.055 8.648-5.3 11.405C10.46 20.578 3.867 12.404 0 2.859A15.253 15.253 0 0 1 8.922 0",
    fill: "#FAD755",
    mask: "url(#bonus-coin_svg__d)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.793 4.613c5.784 0 10.473 4.635 10.473 10.354 0 5.718-4.689 10.353-10.473 10.353-5.783 0-10.472-4.635-10.472-10.353 0-5.719 4.689-10.354 10.472-10.354",
    fill: "#FAD755"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.793 25.32c-5.783 0-10.472-4.635-10.472-10.354 0-3.23 1.497-6.115 3.843-8.014a10.264 10.264 0 0 0-3.11 7.361c0 5.718 4.69 10.353 10.473 10.353 2.516 0 4.824-.877 6.629-2.337a10.5 10.5 0 0 1-7.363 2.99",
    fill: "#FFFF9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.793 4.613c5.784 0 10.473 4.635 10.473 10.354 0 3.69-1.953 6.928-4.893 8.761C31.533 13.805 20.15-.04 8.377 7.656a10.5 10.5 0 0 1 7.416-3.043",
    fill: "#D2A00A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.133 14.967c0 4.553-3.734 8.244-8.34 8.244s-8.34-3.691-8.34-8.244c0-4.554 3.734-8.245 8.34-8.245s8.34 3.691 8.34 8.245Z",
    fill: "#F5BE14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.793 6.722c4.606 0 8.34 3.691 8.34 8.245 0 3.017-1.64 5.656-4.088 7.093A44.137 44.137 0 0 1 9.929 9.105a8.36 8.36 0 0 1 5.864-2.383",
    fill: "#FAD755"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.544 18.016a8.222 8.222 0 0 1-1.336 2.219A44.138 44.138 0 0 1 12.253 7.5a8.345 8.345 0 0 1 2.356-.696 44.159 44.159 0 0 0 8.935 11.212",
    fill: "#F5BE14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.072 23.04c-2.27 0-4.11-1.82-4.11-4.064 0 2.244-1.841 4.063-4.111 4.063 2.27 0 4.11 1.82 4.11 4.064 0-2.244 1.84-4.064 4.11-4.064",
    fill: "#FFF"
  }))));
};
export default SvgBonusCoin;